import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterToolbar = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  onSaveSearch,
  searchQuery,
  onSearchChange 
}) => {
  const marketOptions = [
    { value: 'all', label: 'All Markets' },
    { value: 'eua', label: 'EUA Only' },
    { value: 'oil', label: 'Oil Futures Only' }
  ];

  const impactOptions = [
    { value: 'all', label: 'All Impact Levels' },
    { value: 'high', label: 'High Impact (8-10)' },
    { value: 'medium', label: 'Medium Impact (6-7)' },
    { value: 'low', label: 'Low Impact (4-5)' },
    { value: 'minimal', label: 'Minimal Impact (1-3)' }
  ];

  const sourceOptions = [
    { value: 'all', label: 'All Sources' },
    { value: 'reuters', label: 'Reuters' },
    { value: 'bloomberg', label: 'Bloomberg' },
    { value: 'wsj', label: 'Wall Street Journal' },
    { value: 'ft', label: 'Financial Times' },
    { value: 'platts', label: 'S&P Global Platts' },
    { value: 'argus', label: 'Argus Media' }
  ];

  const timeRangeOptions = [
    { value: '1h', label: 'Last Hour' },
    { value: '6h', label: 'Last 6 Hours' },
    { value: '24h', label: 'Last 24 Hours' },
    { value: '7d', label: 'Last 7 Days' },
    { value: '30d', label: 'Last 30 Days' },
    { value: 'all', label: 'All Time' }
  ];

  const contentTypeOptions = [
    { value: 'all', label: 'All Content' },
    { value: 'news', label: 'News Only' },
    { value: 'events', label: 'Events Only' },
    { value: 'regulatory', label: 'Regulatory Updates' }
  ];

  const hasActiveFilters = () => {
    return filters?.market !== 'all' || 
           filters?.impact !== 'all' || 
           filters?.source !== 'all' || 
           filters?.timeRange !== '24h' ||
           filters?.contentType !== 'all' ||
           searchQuery?.trim() !== '';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-foreground" />
          <h2 className="text-lg font-semibold text-foreground">Filters & Search</h2>
        </div>
        <div className="flex items-center gap-2">
          {hasActiveFilters() && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              className="flex items-center gap-2"
            >
              <Icon name="X" size={16} />
              <span>Clear All</span>
            </Button>
          )}
          <Button
            variant="outline"
            size="sm"
            onClick={onSaveSearch}
            className="flex items-center gap-2"
            disabled={searchQuery?.trim() === ''}
          >
            <Icon name="Save" size={16} />
            <span>Save Search</span>
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-4">
        <Select
          label="Market Type"
          options={marketOptions}
          value={filters?.market}
          onChange={(value) => onFilterChange('market', value)}
          className="w-full"
        />

        <Select
          label="Impact Level"
          options={impactOptions}
          value={filters?.impact}
          onChange={(value) => onFilterChange('impact', value)}
          className="w-full"
        />

        <Select
          label="Source"
          options={sourceOptions}
          value={filters?.source}
          onChange={(value) => onFilterChange('source', value)}
          className="w-full"
          searchable
        />

        <Select
          label="Time Range"
          options={timeRangeOptions}
          value={filters?.timeRange}
          onChange={(value) => onFilterChange('timeRange', value)}
          className="w-full"
        />

        <Select
          label="Content Type"
          options={contentTypeOptions}
          value={filters?.contentType}
          onChange={(value) => onFilterChange('contentType', value)}
          className="w-full"
        />

        <div className="flex flex-col">
          <Input
            label="Search Keywords"
            type="search"
            placeholder="Search news & events..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>
      </div>
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <div className="flex items-center gap-4">
          <span>Showing filtered results</span>
          {hasActiveFilters() && (
            <div className="flex items-center gap-2">
              <Icon name="Filter" size={14} />
              <span className="font-medium">Active filters applied</span>
            </div>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Icon name="RefreshCw" size={14} />
          <span>Auto-refresh: ON</span>
        </div>
      </div>
    </div>
  );
};

export default FilterToolbar;